import View from '../../../Core/View.js';
import BoatExplorerSlider from './BoatExplorerSlider.js';

class BoatExplorer extends View {

	/**
	 * @type {number}
	 */
	static SPRITE_COLS = 4;

	/**
	 * @type {number}
	 */
	static SPRITE_ROWS = 3;

	/**
	 * @type {number}
	 */

	initialize() {

		// Cache selectors
		this.$doc = $(document);
		this.spritesNode = this.$el.find('.boat-explorer__boat__image').get(0);

		// Angle rotation things
		this.totalFrames = BoatExplorer.SPRITE_ROWS * BoatExplorer.SPRITE_COLS;
		this.degreesPerSprite = 360 / this.totalFrames;
		this.percentagePerCol = 100 / (BoatExplorer.SPRITE_COLS - 1);
		this.percentagePerRow = 100 / (BoatExplorer.SPRITE_ROWS - 1);

		this.slider = new BoatExplorerSlider({
			el: this.$el.find('.boat-explorer__slider'),
			onUpdate: this._handleAngleUpdate.bind(this)
		});
	}

	/**
	 * @param {Event} event
	 * @private
	 */
	_handleAngleUpdate(percentage) {
		const angle = percentage * 3.6;
		this._showSpriteForAngle(angle);
	}

	/**
	 * @param {number} angle
	 * @private
	 */
	_showSpriteForAngle(angle) {
		const frame = Math.round(angle / this.degreesPerSprite);
		this._showSpriteForFrame(frame);
	}

	/**
	 * @param {number} angle
	 * @private
	 */
	_showSpriteForFrame(frame) {
		while (frame < 0) {
			frame += this.totalFrames;

		}
		frame = frame % this.totalFrames;

		const horizontalPercentage = this.percentagePerCol * (frame % BoatExplorer.SPRITE_COLS);
		const verticalPercentage = this.percentagePerRow * Math.floor(frame / BoatExplorer.SPRITE_COLS);

		this.spritesNode.style.backgroundPosition = horizontalPercentage + '% ' + verticalPercentage + '%';

	}
}

export default BoatExplorer;


// WEBPACK FOOTER //
// ./js/Views/Modules/BoatExplorer/BoatExplorer.js